// extracted by mini-css-extract-plugin
export default {"wrapper":"DocumentUploadModal_wrapper__wfV7T","icon":"DocumentUploadModal_icon__1KOzn","upload":"DocumentUploadModal_upload__sCJbd","close":"DocumentUploadModal_close__xfYPR"};